import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import { COMPACT_QUERY } from "../../../utils/hooks/useCompact";

const compact = "@media " + COMPACT_QUERY;

export default function ProfitAndCostSkeleton() {
  return (
    <Paper>
      <Skeleton
        variant="text"
        width={180}
        height={28}
        sx={{ mb: 2, borderRadius: 1 }}
      />

      <Grid container spacing={3}>
        <Grid size={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: 234,
              [compact]: { height: 180 },
              borderRadius: 3,
              p: 2,
            }}
          >
            <Skeleton variant="circular" width={32} height={32} sx={{ mb: 2 }} />
            <Skeleton variant="text" width={120} height={24} />
            <Skeleton variant="text" width="60%" height={40} sx={{ mt: 1 }} />
            <Skeleton variant="text" width="40%" height={24} />
          </Box>
        </Grid>

        <Grid size={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: 234,
              [compact]: { height: 180 },
              borderRadius: 3,
              p: 2,
            }}
          >
            <Skeleton variant="circular" width={32} height={32} sx={{ mb: 2 }} />
            <Skeleton variant="text" width={120} height={24} />
            <Skeleton variant="text" width="60%" height={40} sx={{ mt: 1 }} />
            <Skeleton variant="text" width="40%" height={24} />
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}
